import queryString from 'query-string';

import { apiUrl, cancellableRequest } from 'src/services/api.js';
import { createObjectMapper } from 'src/utils/object.js';

const paramsMap = {
  hubs: 'tag_ids',
  locations: 'city_ids',
  onlyContributedHubs: 'invests_only',
  excludeLocations: 'not_cities',
  activeLastYear: 'active_last_year'
};

const mapLocationParams = createObjectMapper({
  filterEmpty: true,
  map: paramsMap,
});

const mapRequestParams = createObjectMapper({
  filterEmpty: true,
  map: paramsMap,
});

export const QAResumesService = {
  getList(params) {
    return cancellableRequest({
      method: 'get',
      url: `${apiUrl}/qa_resumes`,
      params: mapRequestParams(params),
    });
  },
  getMappedParams(params) {
    return mapLocationParams(params);
  },
  syncLocation(params) {
    const mappedParams = mapLocationParams(params);
    const urlQuery = queryString.stringify(mappedParams,{ arrayFormat: 'bracket' });
    window.history.replaceState(params, window.location.title, `${window.location.pathname}?${urlQuery}`);
  }
};
